import { render } from "./DashboardDoughnutChart.vue?vue&type=template&id=3cc17712"
import script from "./DashboardDoughnutChart.vue?vue&type=script&lang=js"
export * from "./DashboardDoughnutChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejp/Desktop/projects/za-gazde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__